<template>
  <UiList
    data-testid="priorityMoreMenu"
    class="max-h-96 min-w-60 divide-y divide-neutral-pale overflow-auto overflow-x-hidden lg:min-w-80">
    <slot />
  </UiList>
</template>

<script setup lang="ts">
import UiList from "@/components/shared/ui/UiList.vue";
</script>
